import { render, staticRenderFns } from "./Zxrs.vue?vue&type=template&id=33bcc12e&scoped=true&"
import script from "./Zxrs.vue?vue&type=script&lang=js&"
export * from "./Zxrs.vue?vue&type=script&lang=js&"
import style0 from "./Zxrs.vue?vue&type=style&index=0&id=33bcc12e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bcc12e",
  null
  
)

export default component.exports